import { Controller } from "@hotwired/stimulus"
import fireConfetti from "canvas-confetti"

export default class extends Controller {
  static values = { autofire: String }

  connect() {
    if (this.autofireValue === "stars") {
      // 100ms gives Turbo and the browser enough time to calculate 
      // the element's final position (getBoundingClientRect)
      setTimeout(() => {
        this.starsFromElement(this.element)
      }, 100)
    }
  }


  /* 
  confetti() {
    fireConfetti({
      particleCount: 150,
      spread: 70,
      origin: { y: 0.6 },
    })
   }
   */

  starsFromTarget(event) {
    this.starsFromElement(event.currentTarget)
  }

  starsFromElement(el) {
    const rect = el.getBoundingClientRect()
    const origin = {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight,
    }
    this.stars(origin)
  }

  starsFromScreenCentre() {
    this.stars({ x: 0.5, y: 0.5 })
  }

  stars(origin = {}) {
    const defaults = {
      spread: 360,
      ticks: 50,
      gravity: 0,
      decay: 0.94,
      startVelocity: 30,
      colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
    }

    const shoot = () => {
      fireConfetti({ ...defaults, origin, particleCount: 40, scalar: 1.2, shapes: ["star"] })
      fireConfetti({ ...defaults, origin, particleCount: 10, scalar: 0.75, shapes: ["circle"] })
    }

    shoot()
    setTimeout(shoot, 100)
    setTimeout(shoot, 200)
  }
}
